import { render } from "./myorders.vue?vue&type=template&id=357d02f0"
import script from "./myorders.vue?vue&type=script&lang=js"
export * from "./myorders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/IdeaProjects/eurogate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__